import { createFileRoute } from "@tanstack/react-router";
import { AuthResetPasswordCard } from "~/routes/auth/-components/AuthResetPasswordCard";
import { returnUrlSearchSchema } from "~/routes/auth/-schemas/return-url-schema";
import { getReturnPath } from "~/routes/auth/-utils/url";

export const Route = createFileRoute("/auth/reset-password/$token")({
  component: RouteComponent,
  validateSearch: returnUrlSearchSchema,
  beforeLoad: ({ params, search }) => {
    return {
      token: params.token,
      returnPath: getReturnPath(search.returnUrl),
    };
  },
  loader: ({ context: { token, returnPath } }) => ({ token, returnPath }),
});

function RouteComponent() {
  const { token, returnPath } = Route.useLoaderData();

  return (
    <AuthResetPasswordCard
      token={token}
      returnPath={returnPath}
    />
  );
}
